import { writable, derived, get } from 'svelte/store';
import { sentryHub, SentryErrorType } from "Utils/sentryHelper";



const formatDateTime = (timestamp, locale, isMultiline) => {

    let date
    if (!timestamp) {
        sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + ": timestamp: " + timestamp);
        date = new Date()
    } else {

        date = new Date(timestamp * 1000);
    }

    let result = ""

    let options = get(optionsStore.options)
    try {
        let result = ""

        let date
        if (!timestamp) {
            sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + ": timestamp: " + timestamp);
            date = new Date()
        } else {

            date = new Date(timestamp * 1000);
        }

        result = [
            new Intl.DateTimeFormat(options.locale).format(date),
            date.toLocaleTimeString([], { timeStyle: 'short' }),
        ].join(isMultiline ? '\n' : ' ');
        return result
    } catch (e) {
        //sentryHub.captureException(e);
        sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_ERROR + ": date: " + date);
        return ""
    }

}


const formatLocalCurrency = (value, currency, locale, decimal) => {

    if (typeof value === 'undefined') {
        //sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + ": local currency");

        return " ";
    }

    let result = "";
    if (value) {
        let sum = value;
        let sum0;
        let sum1;
        if (decimal > 0) {
            sum /= Math.pow(10, decimal);

        }

        result = new Intl.NumberFormat("ru", { notation: "standard", minimumFractionDigits: decimal, maximumFractionDigits: decimal, useGrouping: true }).format(sum)


        result += " " + currency.toUpperCase();
    }
    return result;
}


const formatFunLong = (value, currency, decimal) => {
    if (typeof value === 'undefined') {
        return " ";
    }

    //
    var result = new Intl.NumberFormat("ru", { notation: "standard", minimumFractionDigits: decimal, maximumFractionDigits: decimal, useGrouping: true, roundingMode: 'floor' }).format(value)
    return result + " " + currency.toUpperCase();
}


const cut = (num) => {
    let result = Math.trunc(num * 100) / 100
    return new Intl.NumberFormat('ru').format(result)
}

export const formatFunShort = (value, currency) => {
    if (typeof value !== 'number') {
      return ' '
    }
  
    var ranges = [
      { num: 10 ** 9, symbol: 'B', range: 10 ** 9 },
      { num: 10 ** 6, symbol: 'M', range: 10 ** 6 },
      { num: 10 ** 3, symbol: 'K', range: 10 ** 5 },
      { num: 1, symbol: ' ', range: 0 }
    ]
  
    for (let range of ranges) {
      if (value >= range.range) {

        return currency.toUpperCase() + ' ' + cut(value / range.num).toString() + range.symbol
      }
    }
  
    sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + ": fun value: " + value);
    return value.toString()
  }
  


const formatFun15 = (value, currency, decimal) => {
    var result = new Intl.NumberFormat('ru', {
        notation: 'standard',
        maximumSignificantDigits: 15,
        roundingMode: 'floor',
        roundingPriority: 'lessPrecision',
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal,
        useGrouping: true
      }).format(value)
      return result + ' ' + currency.toUpperCase()
}


const formatEUR = (value) => {
    let result = "1 EUR";

    if (typeof value === 'undefined') {
        sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + ": currency: value: " + value);
        return "";
    }


    //result = new Intl.NumberFormat("de-DE", { style: "currency", currencyDisplay: "code", currency: "EUR", minimumFractionDigits: 0,   notation:"standard" }).format(value)
    result = new Intl.NumberFormat("en", { style: "currency", currencyDisplay: "code", currency: "EUR", minimumFractionDigits: 0, notation: "standard", useGrouping: false }).format(value)





    return result;
}






function createStatusStore() {

    const status = writable()

    return { status }
}



function createOptionsStore() {

    const options = writable({
        currency: "EUR",
        locale: "en",
        exponent: 0,
        userId: "unknown",
        isLobbyEnabled: false,
		isGameListEnabled: false,
    })

    return { options }
}

function createSettingsStore() {

    //const senterPoint
    //const scale = writable(1)

    const settings = writable({
        soundValue: 0,
        isUIleft: false,
        orientation: "portrait",
        mode: "desktop",
        gameScale: 1,
        fontScale: 1,
        isCoinClicked:false,
		isCoinEnabled: true,
    })

    return { settings }

}



// external player wins




function createExternalWinStore() {
    const externalWins = writable([])
    const externalWinToShow = writable(null)
    //const _externalWinToShow = derived(externalWins, ($externalWins) => ($externalWins[0] || null))

    function addExternalWin(value) {
        let options = get(optionsStore.options)
        //console.info("filter own wins")
        if (value.playerId === options.userId)
            return

        externalWins.update(items => ([...items, value]))
    }

    function checkExternalWin() {
        if (!get(externalWinToShow)) {
            //console.log("Store | checkExternalWin")
            let list = get(externalWins)
            if (list && list.length > 0) {
                externalWinToShow.set(list[0])
                externalWins.update(items => {
                    items.shift()
                    return items
                })
            }
        }
    }

    function removeExternalWin() {
        externalWinToShow.set(null)
    }

    return { addExternalWin, externalWinToShow, removeExternalWin, checkExternalWin, externalWins }
}


function createCoinsInfoStore() {


    const coinsInfo = writable([
        {
            cost: 0,
            costLocal: 0,
            left: 0,
            won: 0,
            was: 0
        }])


    const coinValueInfo = derived([coinsInfo], ([$coinsInfo]) => {
        const cost = $coinsInfo.reduce((maxCost, { cost, left }) => left && (cost > maxCost) ? cost : maxCost, 0) || 0;

        const sum = $coinsInfo.reduce((sum, { left }) => sum + left, 0);

        const left = Intl.NumberFormat("en", { minimumFractionDigits: 0, notation: "standard", useGrouping: false }).format(sum)
        return { cost, left };
        //return { cost: 999, left: 77 };
    })

    const coinsLeftFormatted = derived([coinsInfo], ([$coinsInfo]) => {
        const sum = $coinsInfo.reduce((sum, { left }) => sum + left, 0);
        return new Intl.NumberFormat("en", { minimumFractionDigits: 0, notation: "standard", useGrouping: false }).format(sum)
    })


    const maxPrize = derived([coinsInfo], ([$coinsInfo]) => {


        let maxPrize = 0
        $coinsInfo.forEach(value => {
            if (value.cost > maxPrize) {
                maxPrize = value.cost;
            }
        })

        return maxPrize;
    })



    const prizePool = derived([coinsInfo], ([$coinsInfo]) => {

        const sum = $coinsInfo.reduce((sum, { was, cost }) => sum + was * cost, 0);
        return sum;

    })

    const prizeCounts = derived([coinsInfo], ([$coinsInfo]) => {
        const sum = $coinsInfo.reduce((sum, { was }) => sum + was, 0);
        return sum
    })

    const prizePoolFormatted = derived([coinsInfo], ([$coinsInfo]) => {
        const sum = $coinsInfo.reduce((sum, { was, cost }) => sum + was * cost, 0);
        return formatEUR(sum);
    })


    const prizePoolFunLong = derived([prizePool], ($prizePool) => {
        var currencyRate = get(campaingStore.currencyRate)
        var rate = parseFloat(currencyRate.campaignToUserCurrencyValue)
        const sum = $prizePool * rate;

        let options = get(optionsStore.options)

        return formatFunLong(sum, options.currency, options.exponent)
    })


    /**
     * custom formatting
     *  - try show only 6 symbols, but integer part have to be showed completley 
     */
    const prizePoolFunShort = derived([prizePool], ($prizePool) => {
        var currencyRate = get(campaingStore.currencyRate)
        var rate = parseFloat(currencyRate.campaignToUserCurrencyValue)
        let options = get(optionsStore.options)
        const sum = $prizePool * rate;

        // var integerPart = Math.trunc(sum)
        // var nums = integerPart.toString().length
        // if (nums > 5) return sum.toFixed(2);

        //return sum.toFixed(6 - nums)
        return formatFunShort(sum, options.currency, options.exponent)
    })



    function setCoinsInfo(data) {
        data = data.sort((a, b) => b.cost - a.cost);


        var currencyRate = get(campaingStore.currencyRate)
        var rate = parseFloat(currencyRate.campaignToUserCurrencyValue)
        
        let options = get(optionsStore.options)
        
        data.forEach(info => {

            let valueFun = info.cost * rate
            info.costFunLong = formatFunLong(valueFun, options.currency, options.exponent)

            if (info.costLocal) {

                info.costLocalFormatted = formatLocalCurrency(info.costLocal, options.currency, options.locale, options.exponent);
            } else {
                info.costLocalFormatted = ""
                costFunFormatted = ""
                isError = true
            }
        })


        coinsInfo.update(() => ([...data]))
        //TODO:formating
    }




    return {
        setCoinsInfo,
        coinValueInfo,
        coinsInfo,
        coinsLeftFormatted,
        prizePool,
        prizePoolFormatted,
        prizePoolFunShort,
        prizePoolFunLong,
        prizeCounts,
        maxPrize
    }
}


//TODO rename add to set
//campaign
function createCampaign() {
    let campaign = writable(
        {
            id:undefined,
            status: "ongoing",
            startDate: 0,
            finishDate: 0,
            isActive: false,
            skin: "default",
            publicName: '',
            subscriptionMode:"auto",
            minBet: 0

        }
    )

    //social
    const casino = writable(
        {
            category: "commercial"

        })



    const userSubscription = writable(
        {
            subscribed: true
        })

    //external player win

    let wins = []
    let winAlert = writable(false)
    let win = writable(null)

    const playerWinsInfo = writable([])
    const winsInfo = writable([])


    const playerFullWinFormatted = derived([playerWinsInfo], ([$playerWinsInfo]) => {
        const sum = $playerWinsInfo.reduce((sum, { win }) => sum + win, 0);
        return formatEUR(sum)
    })


    const playerFullWinFunLong = derived([playerWinsInfo], ([$playerWinsInfo]) => {
        let options = get(optionsStore.options)
        var currencyRate = get(campaingStore.currencyRate)
        var rate = parseFloat(currencyRate.campaignToUserCurrencyValue)
        const sum = $playerWinsInfo.reduce((sum, { win }) => sum + win, 0);


        return formatFunLong(sum*rate, options.currency, options.exponent)
    })




    const isPlayerWin = derived([playerWinsInfo], ([$playerWinsInfo]) => {
        const sum = $playerWinsInfo.reduce((sum, { win }) => sum + win, 0);
        return sum > 0
        //return $playerWinsInfo.reduce((sum, { win }) => sum + win, 0) > 0;

    })





    const currencyRate = writable(
        {
            userToCampaignCurrency: 1,
            campaignToUserCurrency: 1,
            campaignToUserCurrencyValue: 1
        }
    )


    const playerFullWinInLocalCurrencyFormatted = derived([playerWinsInfo], ([$playerWinsInfo]) => {
        let sum = 0;
        $playerWinsInfo.forEach(winInfo => {
            if (winInfo.winLocal) {
                sum += winInfo.winLocal;
            }
        });

        //TODO sevice
        //or  use optionsStore
        let options = get(optionsStore.options)

        return formatLocalCurrency(sum, options.currency, options.locale, options.exponent)
        //return sum


    })


    function dateFormatted(startDate, locale = "en") {
        //return formatDateTime( Date.now()/1000);



        let date
        if (startDate) {

            date = new Date(startDate * 1000);
        } else {
            sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + ": startDate");
            date = new Date();
        }



        const options = {
            minute: "numeric",
            hour: "numeric",
            day: "numeric",
            month: "long",
            year: "numeric",
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,

        };

        return new Intl.DateTimeFormat(locale, options).format(date)
    }


    function addCampaing(data) {
        if (!data.hasOwnProperty("campaign")) return
        try {

            let options = get(optionsStore.options)
            let trans = {
                id:data.campaign?.id,
                status: data.campaign.status,
                startDate: data.startDate,
                startDateFormatted: dateFormatted(data.startDate, options.locale),
                finishDate: data.finishDate,
                finishDateFormatted: dateFormatted(data.finishDate, options.locale),
                skin: data.campaign.skin,
                isActive: false,
                publicName: data.campaign.publicName ? data.campaign.publicName : 'Spring Fortune Drops'
            }


            //  /add subscribtion mode   
            if (data.campaign.hasOwnProperty("subscriptionMode")) {
                trans.subscriptionMode = data.campaign.subscriptionMode
            }else{
                trans.subscriptionMode = "auto"
            }


            /*
            in this case we don't recive minBet we must not change its value.
            minBet comes only with fetchMenu
            */


            if (data.campaign.hasOwnProperty("minBet")) {

                if (data.campaign.minBet === 0) {
                    trans.minBet = 0
                    trans.minBetLocalFormatted = 0
                    
                } else {
                    trans.minBet = formatEUR(data.campaign.minBet / 100)
                    var currencyRate = get(campaingStore.currencyRate)
                    var rate = parseFloat(currencyRate.campaignToUserCurrencyValue)
                    let socialMinBet = rate* data.campaign.minBet / 100
                    trans.minBetFunLong = formatFunLong(socialMinBet, options.currency, options.exponent)
                    if (options.currency === "EUR") {
                        trans.minBetLocalFormatted = ""
                    } else {
                        trans.minBetLocalFormatted = formatLocalCurrency(data.campaign.minBetLocal, options.currency, options.locale, options.exponent)
                    }
                }
            }

            //hot fix
            //trans.minBet = 0


            campaign.set(trans)
        }
        catch (e) {
            console.error(`${e} ...addCampaing: ${JSON.stringify(data)}`)
            //sentryHub.captureMessage(`SentryErrorType.LS_SERVER_DATA_UNDEFINED ${JSON.stringify(data)}`)
        }
    }


    function addCasino(data) {
        try {
            
            casino.set(data)

        } catch {

            console.error(`addCasion: ${JSON.stringify(data)}`)
            sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + ` addCasion: ${JSON.stringify(data)}`);
        }
    }


    function addUserSubscription(data) {

         var subscriptionMode = get(campaign).subscriptionMode   

        if (subscriptionMode === "auto") return
        try {
            userSubscription.set(data)
        } catch {
            console.error(`addPlayerSubscription: ${JSON.stringify(data)}`)
            sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + ` addPlayerSubscription: ${JSON.stringify(data)}`);
        }
    }


    function addUserCurrencyRate(data) {
        try {
            //User is Current Player
            let userToCampaignCurrency = 1
            if (data.playerToCampaignCurrency) {
                userToCampaignCurrency = data.playerToCampaignCurrency

            } else {

                sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + "playerToCampaignCurrency");
            }

            let campaignToUserCurrency = 1
            let campaignToUserCurrencyValue
            let options = get(optionsStore.options)

            if (data.campaignToPlayerCurrency) {
                var intRaitValue = data.campaignToPlayerCurrency * Math.pow(10, options.exponent);
                campaignToUserCurrencyValue = data.campaignToPlayerCurrency
                campaignToUserCurrency = formatLocalCurrency(intRaitValue, options.currency, options.locale, options.exponent)
            } else {

                sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + "campaignToPlayerCurrency");
            }


            currencyRate.set({ campaignToUserCurrencyValue, campaignToUserCurrency, userToCampaignCurrency })

        } catch {
            console.error(`addUserCurrencyRate: ${JSON.stringify(data)}`)
            currencyRate.set({ campaignToUserCurrency: 1, userToCampaignCurrency: 1 })
        }

    }



    function setPlayerWinsInfo(data) {

        try {
            let _playerWinsInfo = data
            //let isError = false
            let options = get(optionsStore.options)
            var currencyRate = get(campaingStore.currencyRate)
            var rate = parseFloat(currencyRate.campaignToUserCurrencyValue)


            _playerWinsInfo.forEach(winInfo => {
                winInfo.time = formatDateTime(winInfo.time, options.locale);
                winInfo.winFormatted = formatEUR(winInfo.win);

                let winFun = winInfo.win * rate
                winInfo.winFunLong = formatFunLong(winFun, options.currency,  options.exponent)

                if (winInfo.winLocal) {
                    winInfo.winLocalFormatted = formatLocalCurrency(winInfo.winLocal, options.currency, options.locale, options.exponent);


                } else {
                    winInfo.winLocalFormatted = ""
                    isError = true
                }


            });


            playerWinsInfo.set(_playerWinsInfo)

        } catch {
            sentryHub.captureMessage(SentryErrorType.LS_SERVER_DATA_UNDEFINED + ": setPlayerWinsInfo winLocal" + " Input: " + JSON.stringify(data));
            console.error(`setPlayerWinsInfo: ${JSON.stringify(data)}`)
        }
    }


    function setWinsInfo(data) {

        try {
            let _winsInfo = data;
            let options = get(optionsStore.options)
            var currencyRate = get(campaingStore.currencyRate)
            var rate = parseFloat(currencyRate.campaignToUserCurrencyValue)

    

            _winsInfo.forEach(winInfo => {
                winInfo.time = formatDateTime(winInfo.time, options.locale);
                winInfo.winLocalFormatted = formatLocalCurrency(winInfo.winLocal, options.currency, options.locale, options.exponent);
                let winFun = winInfo.win * rate
                winInfo.winFunLong = formatFunLong (winFun, options.currency, options.exponent)

            });

            winsInfo.set(_winsInfo)


        } catch (e) {
            //console.error(`setWinsInfo error: ${e}`)
            console.error(`setWinsInfo: ${JSON.stringify(data)}`)
        }
    }


    //User Win    
    function addWin(newWin) {
        try {

            newWin.isShowed = false
            let options = get(optionsStore.options)
            var currencyRate = get(campaingStore.currencyRate)
            var rate = parseFloat(currencyRate.campaignToUserCurrencyValue)


            newWin.winFormatted = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", minimumFractionDigits: 0, notation: "standard" }).format(newWin.win)
            newWin.winLocalFormatted = formatLocalCurrency(newWin.winLocal, options.currency, options.locale, options.exponent);

            newWin.winFunLong = formatFun15(newWin.win*rate, options.currency, options.exponent)

            wins = [...wins, newWin];

            win.set(wins.shift())
            //            console.log("Store | addWin win:")
            //console.log(get(win))
            winAlert.set(true);
        } catch {
            console.error(`addWin: ${JSON.stringify(newWin)}`)
        }
    }


    function clearWin() {
        //console.log(win)

        if (wins && wins.length > 0) {
            win.set(wins.shift())
            winAlert.set(true)
        } else {

            win.set(null)
            winAlert.set(false)

        }
    }


    function hasNewWins() {
        if (get(win)) {

            return true
        }
        else {
            return false
        }
    }



    function subscribeAlert(fn) {

        return winAlert.subscribe(state => {
            fn(state);
        })
    }



    return {
        addWin,
        win,
        clearWin,
        winsInfo,
        subscribeAlert,
        hasNewWins,
        addCampaing,
        campaign,
        addCasino,
        casino,
        addUserSubscription,
        userSubscription,
        addUserCurrencyRate,
        setPlayerWinsInfo,
        isPlayerWin,
        setWinsInfo,
        playerWinsInfo,
        playerFullWinFormatted,
        playerFullWinInLocalCurrencyFormatted,
        playerFullWinFunLong,
        currencyRate
    }
}





export const optionsStore = createOptionsStore()
export const settingsStore = createSettingsStore()


export const campaingStore = createCampaign()

export const statusStore = createStatusStore()

export const extWinStore = createExternalWinStore()


export const coinsInfoStore = createCoinsInfoStore()
